import { createSelector } from 'reselect';
import { Selector } from 'react-redux';
import { RootState } from '../root-reducer';
import { IPaymentCard } from '../../types/global/generic.types';
import { IPaymentInitialState } from './types';

// Initial selector to access payment state
export const paymentInitialStateSelector: Selector<RootState, IPaymentInitialState> = createSelector(
    (state: RootState) => state.payment,
    payment => payment || {},
);

// Selector for payment methods
export const userPaymentMethodsSelector: Selector<RootState, IPaymentCard[]> = createSelector(
    paymentInitialStateSelector,
    payment => payment.paymentMethods?.filter(payment => !!payment.authorization) || [],
);

// Selector for default payment method
export const userDefaultPaymentMethodSelector: Selector<RootState, IPaymentCard | null> = createSelector(
    userPaymentMethodsSelector,
    methods => methods[0] || null,
);

// Selector for loading state
export const paymentLoadingSelector: Selector<RootState, boolean> = createSelector(
    paymentInitialStateSelector,
    payment => payment.loading || false,
);

// Selector for error state
export const paymentErrorSelector: Selector<RootState, string | null> = createSelector(
    paymentInitialStateSelector,
    payment => payment.error || null,
);
